'use client';

import { useEffect } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
    faClose
} from "@fortawesome/free-solid-svg-icons";

/** Nested modals each call lock/unlock; count ensures we only restore scroll when the last closes. */
let bodyScrollLockCount = 0;
let savedBodyOverflow = '';
let savedHtmlOverflow = '';

function lockBodyScroll() {
    if (bodyScrollLockCount === 0) {
        savedBodyOverflow = document.body.style.overflow;
        savedHtmlOverflow = document.documentElement.style.overflow;
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
    }
    bodyScrollLockCount += 1;
}

function unlockBodyScroll() {
    bodyScrollLockCount = Math.max(0, bodyScrollLockCount - 1);
    if (bodyScrollLockCount === 0) {
        document.body.style.overflow = savedBodyOverflow;
        document.documentElement.style.overflow = savedHtmlOverflow;
    }
}

function Modal(props) {

    useEffect(() => {
        if (!props.show) return undefined;
        lockBodyScroll();
        return () => unlockBodyScroll();
    }, [props.show]);

    const onClose = () => {
        props.onClose && props.onClose();
    }
    
    let modalClasses = "modal";
    if (props.show) {
        modalClasses += " is-active";
    }
    if (props.className) {
        modalClasses += " " + props.className;
    }

    return (
        <div className={modalClasses} id="modal">
            <div className="modal-background" onClick={onClose}></div>
            <div className="modal-content">
                <div className="box box-content px-1-mobile" style={{backgroundColor: '#f2f2f2'}}>
                    <div className="content">
                        <div className="is-flex is-justify-content-space-between">
                            <div>
                            {
                                props.title ? (
                                    <h2 className="has-text-centered mt-2 mb-4">{props.title}</h2>
                                ) : null
                            }
                            </div>
                            <div>
                                <button type="button" className={`button is-danger is-narrow`} onClick={() => onClose()}>
                                    <FontAwesomeIcon  icon={faClose} />
                                </button>
                            </div>
                        </div>
                        {props.children}
                    </div>
                </div> 
            </div>
            {/* <button className="modal-close is-large is-hidden-mobile" aria-label="close" onClick={onClose}></button> */}
        </div>
    );
}

export default Modal;